module.exports = __webpack_public_path__ + "img/locationBlue.e579aa44.svg";